import { Outlet, createFileRoute } from "@tanstack/react-router";

import { Header } from "@/components/ui/header";
import { Navigation } from "../../dashboard/-ui.navigation";
import { api } from "@cvx/_generated/api";
import { convexQuery } from "@convex-dev/react-query";
import { useQuery } from "@tanstack/react-query";

export const Route = createFileRoute(
  "/_app/_auth/partnerships/$partnershipId/_layout",
)({
  component: PartnershipLayout,
});

function PartnershipLayout() {
  const { data: user } = useQuery(convexQuery(api.app.getCurrentUser, {}));
  if (!user) {
    return null;
  }

  return (
    <div className="flex min-h-[100vh] w-full flex-col bg-secondary dark:bg-black">
      <Navigation user={user} />
      <Header user={user} />
      <Outlet />
    </div>
  );
}
